import { render, staticRenderFns } from "./BooleanSwitch.vue?vue&type=template&id=046f60b8&scoped=true&"
import script from "./BooleanSwitch.vue?vue&type=script&lang=js&"
export * from "./BooleanSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046f60b8",
  null
  
)

export default component.exports